import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewRef,
} from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Subject } from "rxjs";
import { first, takeUntil } from "rxjs/operators";
import { Permission } from "../../core/model/permission";
import { PermissionService } from "../../core/service/permission.service";

@Component({
  selector: "app-edit-permission",
  templateUrl: "./edit-permission.component.html",
  styleUrls: ["./edit-permission.component.scss"],
})
export class EditPermissionComponent implements OnInit, OnDestroy {
  pressButton: Boolean = false;
  form: FormGroup;
  loading = true;

  permissionId: number;
  permission: Permission;

  private destroy$ = new Subject<void>();

  constructor(
    private _router: Router,
    private _permissionService: PermissionService,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      code: [null, Validators.compose([Validators.required])],
      label: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    const initialId =
      this._activatedRoute.snapshot.params["permissionId"] ||
      this._activatedRoute.snapshot.paramMap.get("permissionId");
    if (initialId) {
      this.permissionId = initialId;
      this.getPermission(initialId);
    }

    this._activatedRoute.params
      .pipe(takeUntil(this.destroy$))
      .subscribe((params: Params) => {
        const id = params["permissionId"];
        if (id && id !== this.permissionId) {
          this.permissionId = id;
          this.getPermission(id);
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getPermission(permissionId) {
    this.loading = true;
    this._permissionService
      .getPermissionById(permissionId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.permission = { ...data };
          this.loading = false;
          this.safeDetectChanges();
        },
        (error) => {
          console.log(error);
          this.loading = false;
          this.safeDetectChanges();
        }
      );
  }

  save(): void {
    this.pressButton = true;
    this._permissionService
      .update(this.permission)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.goToList();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/permission");
  }

  private safeDetectChanges(): void {
    const view = this.cdr as ViewRef;
    if (view && !view.destroyed) {
      this.cdr.detectChanges();
    }
  }
}
